
import { get as getReduxStore } from './redux-store.js';

import { show as showNotification } from 'zoomforth_app_basics/action_creators/notifications.js';



const get = function() {
  if (!getReduxStore()) {
    throw new Error('You must `init` the reduxStore before you can use the notification-system app-global');
  }

  return {
    addNotification: addNotification
  };
};

const addNotification = function({ level, ...rest }) {
  getReduxStore().dispatch(showNotification(rest, level));
};


export { get, addNotification };
export default { get, addNotification };
